export enum SOCIAL_EMERGENCE_NODE_PROPERTY_TYPE {
    name = 'name',
    socialCapitalRatio = 'socialCapitalRatio',
    rank = 'rank',
    connections = 'connections',
}
